import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "maintenance" }
const _hoisted_2 = { class: "maintenance__container" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h1", { class: "maintenance__title" }, "Sitio en construcción", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "maintenance__description" }, [
  /*#__PURE__*/_createVNode("p", { class: "text-body--xl" }, "En breves anunciaremos novedades en TheLittlePot y CouCeramica"),
  /*#__PURE__*/_createVNode("p", { class: "text-body--md" }, "Sigue nuestras redes para estar conectado")
], -1)
const _hoisted_5 = { class: "maintenance__social" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createVNode("div", _hoisted_5, [
        _createVNode(_component_Button, {
          icon: "instagram",
          href: "https://www.instagram.com/the.little.pot/",
          theme: "text",
          title: "Instagram TLP",
          text: "TheLittlePot"
        }),
        _createVNode(_component_Button, {
          icon: "instagram",
          href: "https://www.instagram.com/couceramica/",
          theme: "text",
          title: "Instagram COU",
          text: "CouCeramica"
        }),
        _createVNode(_component_Button, {
          icon: "etsy",
          href: "https://www.etsy.com/es/shop/thelittlepotceramics",
          theme: "text",
          title: "Etsy",
          text: "Etsy"
        })
      ])
    ])
  ]))
}